import React from 'react';
import { BurgerMenuContainer } from '../burger-menu/burger-menu';
import { Navbar } from '../navbar/navbar';
import { connect } from 'react-redux';
import { JobsListContainer } from './job-list';
import { ChangePasswordModal } from '../create-account/change-password';
import { getJobs } from '../../state/jobs/actions';

const Jobs = React.createClass({
  componentWillMount() {
    const { dispatch } = this.props;
    dispatch(getJobs());
  },

  renderNavbar() {
    return (
      <div id="outer-container">
        <BurgerMenuContainer
          pageWrapId={'page-wrap'}
          outerContainerId="outer-container"
        />
        <Navbar {...this.props} title={'Jobs'} />
      </div>
    );
  },

  renderMain() {
    return (
      <div>
        <JobsListContainer jobs={this.props.jobs} />
      </div>
    );
  },

  render() {
    return (
      <div>
        <ChangePasswordModal />
        {this.renderNavbar()}
        {this.renderMain()}
      </div>
    );
  }
});

const mapStateToProps = state => {
  return {
    isAuthenticated: state.auth.get('isAuthenticated'),
    account: state.auth.get('user'),
    isLoading: state.profile.get('isLoading'),
    jobs: state.jobs.get('jobs'),
    profile: state.auth.get('user')
  };
};

const mapDispatchToProps = dispatch => ({
  dispatch
});

export const JobsContainer = connect(mapStateToProps, mapDispatchToProps)(Jobs);



/** WEBPACK FOOTER **
 ** ./src/components/jobs/jobs.jsx
 **/